import React from 'react';
import './Accreditations.css';

import aicteIcon from '../../assets/images/icons/book.png';
import nbaIcon from '../../assets/images/icons/users.png';
import nirfIcon from '../../assets/images/icons/blub.png';
import naacIcon from '../../assets/images/icons/world.png';
import { Link } from 'react-router-dom';



const Accreditations = () => {



  return (
    
    <section className="Accreditations-section">
        <div className="container">

          <div className="row">
              <h1 className="text-center text-white mb-4" data-aos="fade-up" data-aos-delay="200">Accreditations</h1>
              <div className="col-lg-12">
                <div className="achievements-gallery" data-aos="fade-up" data-aos-delay="700">
                  <div  className="row g-4">
                    <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                      <div className="accreditations-box2">
                        <img src={aicteIcon} alt="A.I.C.T.E." className=""/>
                      
                        {/* <a href="https://vcmdhyd.ac.in/vcehyd/approvals-and-accreditations/aicte.php"> */}
                        <Link to="/accreditations-details">
                          <h3>A.I.C.T.E.</h3>
                          <p>
                            All India Council for Technical Education
                          </p>
                        </Link>
                      </div>
                    </div>

                     <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                      <div className="accreditations-box2">
                        <img src={nbaIcon} alt="N.B.A." className=""/>
                      
                        {/* <a href="#"> */}
                        <Link to="/AccreditationsDetails">
                          <h3>N.B.A.</h3>
                          <p>
                            National Board of Accreditation
                          </p>
                        </Link>
                      </div>
                    </div>

                   <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                      <div className="accreditations-box2">
                        <img src={nirfIcon} alt="N.I.R.F." className=""/>
                      
                        <Link href="#">
                          <h3>N.I.R.F.</h3>
                          <p>
                            National Institutional Ranking Framework
                          </p>
                        </Link>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                      <div className="accreditations-box2">
                        <img src={naacIcon} alt="N.A.A.C" className=""/>
                      
                        <Link href="#">
                          <h3>N.A.A.C</h3>
                          <p>
                            National Assessment and Accreditation Council
                          </p>
                        </Link>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                      <div className="accreditations-box2">
                        <img src={naacIcon} alt="U.G.C." className=""/>
                      
                        <Link href="#">
                          <h3>U.G.C.</h3>
                          <p>
                            University Grants Commission
                          </p>
                        </Link>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                      <div className="accreditations-box2">
                        <img src={naacIcon} alt="A.R.I.I.A." className=""/>
                      
                        <Link href="#">
                          <h3>A.R.I.I.A.</h3>
                          <p>
                            Atal Ranking of Institutions on Innovation Achievements
                          </p>
                        </Link>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                      <div className="accreditations-box2">
                        <img src={naacIcon} alt="I.Q.A.C." className=""/>
                      
                        <Link href="#">
                          <h3>I.Q.A.C.</h3>
                          <p>
                            Internal Quality Assurance Cell
                          </p>
                        </Link>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                      <div className="accreditations-box2">
                        <img src={naacIcon} alt="A.I.S.H.E." className=""/>
                      
                        <Link href="#">
                          <h3>A.I.S.H.E.</h3>
                          <p>
                            All India Survey on Higher Education 
                          </p>
                        </Link>
                      </div>
                    </div>
                    
                    

                  </div>
                </div>
              </div>
            </div>
            
        </div>

    </section>

    
  );
};

export default Accreditations;
